import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../../../bff-api/bff';
import { BffQueryKey } from '../../../bff-api/model/BffQueryKey';
import { isServer } from '../../../utils/utils';
import type { BuildStatusResponse } from '../models/BuildStatusResponse';

export const useBuildStatus = (): UseQueryResult<BuildStatusResponse> =>
    useBffGet('/utils/build-status', [], [BffQueryKey.BUILD_STATUS], {
        enabled: !isServer,
    });
